// scroll bar
import 'simplebar/src/simplebar.css';
import './index.css';

import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { store } from './store';
import { Provider } from 'react-redux';
import { setAxios } from './services/network';
import ScrollToTop from './components/scroll-to-top/ScrollToTop';

setAxios(store.getState().userInfo.userInfo.token);

ReactDOM.render(
  <Provider store={store}>
    <HelmetProvider>
      <HashRouter>
        {/* <ScrollToTop /> */}
        <App />
      </HashRouter>
    </HelmetProvider>
  </Provider>,
  document.getElementById('root')
);
